export default {
    validationEmail() {
        function validateEmail(elementValue1) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(elementValue1)
        }

        let contactEmail = $('.form-email');

        contactEmail.keyup(function () {
            let value = $(this).val();
            let valid = validateEmail(value);
            if (!valid) {
                $(this).closest('.form-item').addClass('input-invalid');
                $(this).closest('form').find('.form-error-message.error-message').slideDown(300);
            } else {
                $(this).closest('.form-item').removeClass('input-invalid');
                $(this).closest('form').find('.form-error-message.error-message').slideUp(300);
            }
        });
    },

    validationPhone() {
        let validateNumbers = function (elementValue2) {
            return /^[-+]?[0-9]+$/.test(elementValue2);
        };

        let contactPhone = $('.form-phone');

        contactPhone.keyup(function () {
            let value = $(this).val();
            let valid = validateNumbers(value);
            if (!valid) {
                $(this).closest('.form-item').addClass('input-invalid');
                $(this).closest('form').find('.form-error-message.error-message').slideDown(300);
            } else {
                $(this).closest('.form-item').removeClass('input-invalid');
                $(this).closest('form').find('.form-error-message.error-message').slideUp(300);
            }
        });
    },
}